
export default class ReviewsRankingController {

    constructor (
        $filter,
        $state,
        $window,
        $timeout,
        Review,
        brand,
	    stores,
	    selectedStore,
        endDate,
        startDate,
        storesInfoLoader,
        storesInfo
    ) {
        this.translate        = $filter('translate');
        this.$state           = $state;
        this.$window          = $window;
        this.$timeout         = $timeout;
        this.Review           = Review;
        this.brand            = brand;
        this.stores           = stores;
        this.selectedStore    = selectedStore;
        this.endDate          = endDate;
        this.startDate        = startDate;
        this.storesInfoLoader = storesInfoLoader;
        this.storesInfo       = storesInfo;

        this.hasRatings = !!this.storesInfo.filter(elem => elem.ratingCount > 0).length;

        this.hasNPS = !!this.storesInfo.filter(elem =>  elem.npsValue && elem.npsValue.count).length;

        this.hasRevenue = !!this.storesInfo.filter(elem =>  elem.revenue > 0).length;

        this.headers = [
            { key: 'storeID', label: this.translate('STOREID'), type: 'text' },
            { key: 'storeName', label: this.translate('NAME'), type: 'text' },
            { key: 'emailCount', label: this.translate('EMAILCOUNT'), type: 'text' }
        ];

        if (this.hasRatings) {
            this.headers = this.headers.concat([
                { key: 'ratingCount', label: this.translate('RATINGCOUNT'), type: 'text' },
                { key: 'ratingAvg', label: this.translate('RATINGAVG'), type: 'ratings-with-value' }
            ]);
        }

        if (this.hasRevenue) {
            this.headers.push({ key: 'revenue', label:this.translate('REVENUE'), type: 'currency' });
        }

        if (this.hasNPS) {
            this.headers.push({ key: 'npsValue', label:this.translate('NPSVALUE'), type: 'npsconfig', sortBy: 'npsValue.text' });
        }

        this.storesInfo = this.formatStoreInfoForCustomTable(this.storesInfo);

    }

    getNpsScoreDoughnutConfig(npsstats) {
        return ({
            data: {
                labels: [
                    'Promoters',
                    'Passives',
                    'Detractors'
                ],
                datasets: [{
                    data: [npsstats.promoters, npsstats.passives, npsstats.detractors],
                    backgroundColor: [
                        "#35CE7D",
                        "#0CAFD1",
                        "#F2624F"
                    ],
                    hoverBackgroundColor: [
                        "#35CE8D",
                        "#0CAFE1",
                        "#F2625F"
                    ]
                }]
            },
            text: npsstats.score
        });
    }

    formatStoreInfoForCustomTable(storesInfoArray) {

        if(!storesInfoArray){
            return [];
        }

         return storesInfoArray
            .filter(elt => elt.emailCount || elt.ratingCount || elt.ratingAvg || elt.revenue)
            .map(elt => ({
                ...elt,
                npsValue: elt.npsValue && this.getNpsScoreDoughnutConfig(elt.npsValue)
            }));
    }

}

ReviewsRankingController.$inject = [
    '$filter',
    '$state',
    '$window',
    '$timeout',
    'Review',
    'brand',
	'stores',
	'selectedStore',
    'endDate',
    'startDate',
    'storesInfoLoader',
    'storesInfo'
];



// WEBPACK FOOTER //
// ./src/page/reviewsRanking/reviewsRanking.controller.js